"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataTypes = exports.counter = exports.unitState = exports.battery = exports.volatileOrganicCompound = exports.temperatureK = exports.soundPressureLevel = exports.relativeHumidity = exports.pressure = exports.illuminance = exports.healthScore = exports.carbonDioxide = exports.assetUtilization = void 0;
const lodash_1 = require("lodash");
const asset_utilization_1 = require("./asset-utilization");
Object.defineProperty(exports, "assetUtilization", { enumerable: true, get: function () { return asset_utilization_1.assetUtilization; } });
const battery_1 = require("./battery");
Object.defineProperty(exports, "battery", { enumerable: true, get: function () { return battery_1.battery; } });
const carbon_dioxide_1 = require("./carbon-dioxide");
Object.defineProperty(exports, "carbonDioxide", { enumerable: true, get: function () { return carbon_dioxide_1.carbonDioxide; } });
const counter_1 = require("./counter");
Object.defineProperty(exports, "counter", { enumerable: true, get: function () { return counter_1.counter; } });
const health_score_1 = require("./health-score");
Object.defineProperty(exports, "healthScore", { enumerable: true, get: function () { return health_score_1.healthScore; } });
const illuminance_1 = require("./illuminance");
Object.defineProperty(exports, "illuminance", { enumerable: true, get: function () { return illuminance_1.illuminance; } });
const pressure_1 = require("./pressure");
Object.defineProperty(exports, "pressure", { enumerable: true, get: function () { return pressure_1.pressure; } });
const relative_humidity_1 = require("./relative-humidity");
Object.defineProperty(exports, "relativeHumidity", { enumerable: true, get: function () { return relative_humidity_1.relativeHumidity; } });
const sound_pressure_level_1 = require("./sound-pressure-level");
Object.defineProperty(exports, "soundPressureLevel", { enumerable: true, get: function () { return sound_pressure_level_1.soundPressureLevel; } });
const temperature_k_1 = require("./temperature-k");
Object.defineProperty(exports, "temperatureK", { enumerable: true, get: function () { return temperature_k_1.temperatureK; } });
const unit_state_1 = require("./unit-state");
Object.defineProperty(exports, "unitState", { enumerable: true, get: function () { return unit_state_1.unitState; } });
const volatile_organic_compound_1 = require("./volatile-organic-compound");
Object.defineProperty(exports, "volatileOrganicCompound", { enumerable: true, get: function () { return volatile_organic_compound_1.volatileOrganicCompound; } });
exports.dataTypes = lodash_1.orderBy([
    asset_utilization_1.assetUtilization,
    carbon_dioxide_1.carbonDioxide,
    health_score_1.healthScore,
    illuminance_1.illuminance,
    pressure_1.pressure,
    relative_humidity_1.relativeHumidity,
    sound_pressure_level_1.soundPressureLevel,
    temperature_k_1.temperatureK,
    volatile_organic_compound_1.volatileOrganicCompound,
    battery_1.battery,
    unit_state_1.unitState,
    counter_1.counter,
], dataType => dataType.order);
//# sourceMappingURL=index.js.map